import { ApplicantExamModel } from "@shared/models";

import { ChallengeStyle } from "./enums";

/**
 * checks if challenge meets the condition to take webcam screenshots
 *
 * @param exam
 * @param challengeId
 * @returns
 */
export const canTakeWebcamScreenshots = ({
  exam,
  challengeId,
  hasVerifiedLiveness,
}: {
  exam: ApplicantExamModel;
  challengeId: number;
  hasVerifiedLiveness: boolean;
}): boolean => {
  const challenge = exam.getChallengeByChallengeId(challengeId);

  if (!exam.isInProgress()) {
    return false;
  }
  if (!exam.isChallengeStarted(challengeId)) {
    return false;
  }

  if (!hasVerifiedLiveness) {
    return false;
  }

  if (!ChallengeStyle.canWebcam(challenge.style)) {
    return false;
  }

  return true;
};
